import {
  CommonActions,
  RouteProp,
  useFocusEffect,
  useNavigation,
  useRoute,
} from '@react-navigation/native'
import React, { useContext, useEffect, useState } from 'react'
import { LogisticsRoutes, RootParams } from '../../../../../navigator/types'
import { TakePhoto } from '../../../../../components/TakePhoto'
import { AlertMessage } from '../../../../../components/AlertMessage'
import { StackNavigationProp } from '@react-navigation/stack'
import { FuelContext } from '../../../../../context/Logistics/fuel/FuelProvider'
import { BodyAlert } from '../../components/BodyAlert'

export const FinalPhotoMeter = () => {
  const { handleTakePhoto, handleSaveRecord, handleResetForm, form } = useContext(FuelContext)
  const navigation = useNavigation<StackNavigationProp<LogisticsRoutes, 'FinalPhotoMeter'>>()
  const rootNavigation = useNavigation<StackNavigationProp<RootParams>>()
  const route = useRoute<RouteProp<LogisticsRoutes, 'FinalPhotoMeter'>>()
  const [show, setShow] = useState({
    alert: false,
    camera: true,
  })

  const [photo, setPhoto] = useState('')

  const handlePause = () => {
    handleSaveRecord({ ...form, stateForm: 'in-progress' })
    handleResetForm()
    rootNavigation.dispatch(CommonActions.reset({ index: 0, routes: [{ name: 'HomeScreen' }] }))
  }

  const handleNavigate = () => {
    handleTakePhoto({ type: 'finalPhotoMeter', uri: photo })
    setShow({ alert: false, camera: false })
    navigation.navigate('MeterLog', { returnToSummary: !!route.params?.returnToSummary })
  }
  useFocusEffect(
    React.useCallback(() => {
      setShow({
        alert: false,
        camera: true,
      })

      return () => {
        setShow({
          alert: false,
          camera: false,
        })
      }
    }, []),
  )

  useEffect(() => {
    if (route.params) {
      setShow({ alert: !!route.params.uri, camera: !route.params.uri })
      setPhoto(route.params.uri)
    }
  }, [route.params])
  return (
    <>
      {show.camera && (
        <TakePhoto
          getPhoto={(uri) => {
            setPhoto(uri)
            setShow({
              alert: true,
              camera: false,
            })
          }}
          capturingText='FOTO MEDIDOR FINAL'
          indicationsText='Llena el estanque de combustible, y cuando hayas terminado, vuelve a tomar otra foto del medidor'
          pauseBtn={{ show: true, action: handlePause }}
        />
      )}

      {show.alert && (
        <AlertMessage
          title=''
          cancelLabel='Repetir foto'
          successLabel='Continuar'
          action={handleNavigate}
          cancelButton
          style={{ position: 'absolute' }}
          actionCancelButton={() => setShow({ alert: false, camera: true })}
        >
          <BodyAlert
            title='Foto tomada con éxito'
            onClose={() => setShow({ alert: false, camera: true })}
            uri={photo}
          />
        </AlertMessage>
      )}
    </>
  )
}
